module.exports = __webpack_public_path__ + "static/media/mybg.bce45080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mybg.png
// module id = 667
// module chunks = 0